exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Backtest-Tabs-___style__wrapper___t_e5K .ant-tabs-bar{margin-bottom:0;border-bottom:none}.src-components-Backtest-Tabs-___style__wrapper___t_e5K .ant-tabs.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab{border:none}.src-components-Backtest-Tabs-___style__spin____kZp0{background:white}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "src-components-Backtest-Tabs-___style__wrapper___t_e5K",
	"spin": "src-components-Backtest-Tabs-___style__spin____kZp0"
};